import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { UserToken } from 'vidis-common';
import { UserService } from '../../services/user/user.service';
import { jwtDecode } from 'jwt-decode';
import { ConfigurationService } from '@smals/ngx-configuration-service';

export const authGuard: CanActivateFn = async () => {
  const keycloakService = inject(KeycloakService);
  const userService = inject(UserService);
  const configurationService = inject(ConfigurationService);

  const authenticated = await keycloakService.isLoggedIn();

  if (!authenticated) {
    keycloakService.login()
      .catch(e => console.error('error during login', e));
    return false;
  } else if (configurationService.getEnvironment() !== 'local') {
    const isProfessionalUrl: boolean = keycloakService.getKeycloakInstance().clientId == 'nihdi-vidis-caregiver';
    const token = await keycloakService.getToken();
    const decodedTokenFull = jwtDecode<UserToken>(token);
    const isCaregiverToken: boolean = userService.isCaregiver(decodedTokenFull);
    if (isCaregiverToken !== isProfessionalUrl) {
      await keycloakService.login({prompt: 'login'});
    }
  }

  return true;
};
